import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaEye,
  FaCheck,
  FaCertificate,
  FaDownload,
  FaSearch,
} from "react-icons/fa";
import {
  MdApps,
  MdAssignment,
  MdBadge,
  MdBuild,
  MdBusinessCenter,
  MdCategory,
  MdContactMail,
  MdDashboard,
  MdEvent,
  MdGrade,
  MdGroup,
  MdImage,
  MdInsertChart,
  MdLink,
  MdPerson,
  MdPhotoLibrary,
  MdPostAdd,
  MdSettings,
  MdSlideshow,
  MdStar,
  MdStore,
  MdTv,
  MdVerified,
  MdWork,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FacebookEmbed,
  InstagramEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"

const API = "https://infosightapi.emedha.in";


const Info = ({ label, value }) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid #eee",
      borderRadius: 8,
      padding: "10px 12px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    }}
  >
    <strong style={{ color: "var(--primary)" }}>{label}:</strong>
    <div style={{ marginTop: 4, color: "#555" }}>{value}</div>
  </div>
);

const spinnerStyle = {
  width: "14px",
  height: "14px",
  border: "2px solid #fff",
  borderTop: "2px solid transparent",
  borderRadius: "50%",
  display: "inline-block",
  animation: "spin 0.7s linear infinite",
};

// Keyframes injected inline
const spinKeyframes = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;



const AdminDashboard = () => {
  const adminEmail = sessionStorage.getItem("adminEmail");
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem("activeComponent") || "Dashboard"
  );
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  const [images, setImages] = useState([]); // State for storing uploaded images

 



//--- Projects Page ---//
const [projects, setProjects] = useState([]);
const [formP, setFormP] = useState({
  name: "",
  category: "Hospitality",
  country: "United Arab Emirates",
  scope_of_work: "",   // <-- ADD
  description: "",     // <-- ADD
  image: null
});

const [editingP, setEditingP] = useState(null);
const [showModalP, setShowModalP] = useState(false);

// Pagination
const [currentPageP, setCurrentPageP] = useState(1);
const itemsPerPageP = 10;
const totalPagesP = Math.ceil(projects.length / itemsPerPageP);
const currentItemsP = projects.slice(
  (currentPageP - 1) * itemsPerPageP,
  currentPageP * itemsPerPageP
);


const fetchProjects = async () => {
  const { data } = await axios.get(`${API}/api/projects`);
  setProjects(data);
};

useEffect(() => {
  fetchProjects();
}, []);

const handleImageP = (e) => {
  setFormP({ ...formP, image: e.target.files[0] });
};

const handleSubmitP = async (e) => {
  e.preventDefault();
  const data = new FormData();

  data.append("name", formP.name);
  data.append("category", formP.category);
  data.append("country", formP.country);
// ADD THESE
data.append("scope_of_work", formP.scope_of_work);
data.append("description", formP.description);

  if (formP.image instanceof File) {
    data.append("image", formP.image);
  }

  if (editingP) {
    await axios.put(`${API}/api/projects/${editingP}`, data);
  } else {
    await axios.post(`${API}/api/projects`, data);
  }

  setShowModalP(false);
  setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", image: null });
  setEditingP(null);
  fetchProjects();
};


const handleEditP = (p) => {
  setFormP({ name: p.name, category: p.category, country: p.country,   scope_of_work: p.scope_of_work,  description: p.description, image: p.image });
  setEditingP(p.id);
  setShowModalP(true);
};

const handleDeleteP = async (id) => {
  if (window.confirm("Delete this project?")) {
    await axios.delete(`${API}/api/projects/${id}`);
    fetchProjects();
  }
};


//-----Hero Sliders -------//



 const [sliders, setSliders] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [form, setForm] = useState({
    title: "",
    location: "",
    image: null,
    order_no: "",
  });

  const [editingID, setEditingID] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(sliders.length / itemsPerPage);
  const currentItems = sliders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Fetch Sliders
  const fetchSliders = async () => {
    const { data } = await axios.get(`${API}/api/hero-sliders`);
    setSliders(data);
  };

  useEffect(() => {
    fetchSliders();
  }, []);


  const orderOptions = Array.from(
  { length: sliders.length + (editingID ? 0 : 1) },
  (_, i) => i + 1
);


  const handleImage = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("title", form.title);
    fd.append("location", form.location);
    if (form.image instanceof File) fd.append("image", form.image);
    fd.append("order_no", form.order_no);


    if (editingID) {
      await axios.put(`${API}/api/hero-sliders/${editingID}`, fd);
    } else {
      await axios.post(`${API}/api/hero-sliders`, fd);
    }

    setShowModal(false);
    setEditingID(null);
    setForm({ title: "", location: "", image: null });
    fetchSliders();
  };

  const handleEdit = (slide) => {
    setEditingID(slide.id);
    setForm({
      title: slide.title,
      location: slide.location,
      image: slide.image,
          order_no: slide.order_no,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this slide?")) return;
    await axios.delete(`${API}/api/hero-sliders/${id}`);
    fetchSliders();
  };

  // ----- Job Applications -------//

const [applications, setApplications] = useState([]);

// Pagination
const [currentPageA, setCurrentPageA] = useState(1);
const itemsPerPageA = 10;
const totalPagesA = Math.ceil(applications.length / itemsPerPageA);

const currentItemsA = applications.slice(
  (currentPageA - 1) * itemsPerPageA,
  currentPageA * itemsPerPageA
);

// Fetch Applications
const fetchApplications = async () => {
  const { data } = await axios.get(`${API}/api/applications`);
  setApplications(data);
};

useEffect(() => {
  fetchApplications();
}, []);





  // ---- Services Menus ---- //

const [menus, setMenus] = useState([]);
const [menuName, setMenuName] = useState("");
const [editingIDSm, setEditingIDSm] = useState(null);

// Pagination
const [currentPageSm, setCurrentPageSm] = useState(1);
const itemsPerPageSm = 10;
const totalPagesSm = Math.ceil(menus.length / itemsPerPageSm);
const currentItemsSm = menus.slice(
  (currentPageSm - 1) * itemsPerPageSm,
  currentPageSm * itemsPerPageSm
);

// Fetch menus
const fetchMenus = async () => {
  const { data } = await axios.get(`${API}/api/services-menus`);
  setMenus(data);
};

useEffect(() => {
  fetchMenus();
}, []);

// Add / Edit menu
const handleSubmitMenu = async (e) => {
  e.preventDefault();

  if (!menuName.trim()) return;

  if (editingIDSm) {
    // Update
    await axios.put(`${API}/api/services-menus/${editingIDSm}`, {
      menu_name: menuName,
    });
  } else {
    // Add
    await axios.post(`${API}/api/services-menus`, {
      menu_name: menuName,
    });
  }

  setMenuName("");
  setEditingIDSm(null);
  fetchMenus();
};

// Edit Row
const handleEditMenu = (menu) => {
  setMenuName(menu.menu_name);
  setEditingIDSm(menu.id);
};

// Delete Row
const handleDeleteMenu = async (id) => {
  if (!window.confirm("Delete this menu?")) return;

  await axios.delete(`${API}/api/services-menus/${id}`);
  fetchMenus();
};



//-------- Serices -----------//



  const [services, setServices] = useState([]);

  // Form data
const [formS, setFormS] = useState({
  menu_id: "",
  image: null,
  heading: "",
  paragraph: "",
  bullet_points: ""
});


  const [editingS, setEditingS] = useState(null);
  const [showModalS, setShowModalS] = useState(false);

  // Pagination
  const [currentPageS, setCurrentPageS] = useState(1);
  const itemsPerPageS = 10;
  const totalPagesS = Math.ceil(services.length / itemsPerPageS);

  const currentItemsS = services.slice(
    (currentPageS - 1) * itemsPerPageS,
    currentPageS * itemsPerPageS
  );


  const addBullet = () => {
  setFormS({ ...formS, bullet_points: [...formS.bullet_points, ""] });
};


  // Fetch Services
  const fetchServices = async () => {
    const { data } = await axios.get(`${API}/api/services`);
    setServices(data);
  };

  useEffect(() => {
    fetchMenus();
    fetchServices();
  }, []);

  // Image Handler
  const handleImageS = (e) => {
    setFormS({ ...formS, image: e.target.files[0] });
  };

    // Add new heading & description block
  const addContentBlock = () => {
    setFormS({
      ...formS,
      content: [...formS.content, { heading: "", description: "" }],
    });
  };

  // Remove block
  const removeContentBlock = (index) => {
    const updated = [...formS.content];
    updated.splice(index, 1);
    setFormS({ ...formS, content: updated });
  };

  // Update heading/description
  const updateContentBlock = (index, field, value) => {
    const updated = [...formS.content];
    updated[index][field] = value;
    setFormS({ ...formS, content: updated });
  };


    // Submit (Add or Update)
const handleSubmitS = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("menu_id", formS.menu_id);
  data.append("paragraph", formS.paragraph);
  data.append("heading", formS.heading);
 data.append(
  "bullet_points",
  JSON.stringify(formS.bullet_points.split("\n").filter(x => x.trim() !== ""))
);


  if (formS.image instanceof File) {
    data.append("image", formS.image);
  }

  if (editingS) {
    await axios.put(`${API}/api/services/${editingS}`, data);
  } else {
    await axios.post(`${API}/api/services`, data);
  }

  setShowModalS(false);
  setEditingS(null);

  setFormS({
    menu_id: "",
    image: null,
    paragraph: "",
    heading: "",
      bullet_points: ""
  });

  fetchServices();
};


  // Edit
  const handleEditS = (service) => {
 setFormS({
  menu_id: service.menu_id,
  image: service.image,
  heading: service.heading,
  paragraph: service.paragraph,
  bullet_points: JSON.parse(service.bullet_points).join("\n"),
});


    setEditingS(service.id);
    setShowModalS(true);
  };

  // Delete
  const handleDeleteS = async (id) => {
    if (window.confirm("Delete this service?")) {
      await axios.delete(`${API}/api/services/${id}`);
      fetchServices();
    }
  };




//---------------  Clients --------------------//

const [clients, setClients] = useState([]);

const [formC, setFormC] = useState({
  client_name: "",
  image: null
});

const [editingC, setEditingC] = useState(null);
const [showModalC, setShowModalC] = useState(false);


const fetchClients = async () => {
  const { data } = await axios.get(`${API}/api/clients`);
  setClients(data);
};

useEffect(() => {
  fetchClients();
}, []);



const handleImageC = e => {
  setFormC({ ...formC, image: e.target.files[0] });
};



const handleSubmitC = async e => {
  e.preventDefault();

  const data = new FormData();

  data.append("client_name", formC.client_name);

  if (formC.image instanceof File) {
    data.append("image", formC.image);
  }

  if (editingC) {
    await axios.put(`${API}/api/clients/${editingC}`, data);
  } else {
    await axios.post(`${API}/api/clients`, data);
  }

  setShowModalC(false);
  setEditingC(null);

  setFormC({ client_name:"", image:null });

  fetchClients();
};


const handleEditC = client => {
  setFormC({
    client_name: client.client_name,
    image: client.image
  });

  setEditingC(client.id);
  setShowModalC(true);
};


const handleDeleteC = async id => {
  if (!window.confirm("Delete this client?")) return;

  await axios.delete(`${API}/api/clients/${id}`);
  fetchClients();
};


// -------- Careers ----------- //

const [careers, setCareers] = useState([]);

const [formCar, setFormCar] = useState({
  post: "",
  experience: "",
  description: "",
 sections: [] ,
  vacancies: ""
});

const [editingCar, setEditingCar] = useState(null);
const [showModalCar, setShowModalCar] = useState(false);

// Pagination
const [currentPageCar, setCurrentPageCar] = useState(1);
const itemsPerPageCar = 10;
const totalPagesCar = Math.ceil(careers.length / itemsPerPageCar);

const currentItemsCar = careers.slice(
  (currentPageCar- 1) * itemsPerPageCar,
  currentPageCar * itemsPerPageCar
);


const addSection = () => {
  setFormCar(prev => ({
    ...prev,
    sections: Array.isArray(prev.sections)
      ? [...prev.sections, { heading: "", content: "" }]
      : [{ heading: "", content: "" }]
  }));
};


const updateSection = (index, field, value) => {
  const updated = [...formCar.sections];
  updated[index][field] = value;
  setFormCar({ ...formCar, sections: updated });
};

const removeSection = (index) => {
  const updated = formCar.sections.filter((_, i) => i !== index);
  setFormCar({ ...formCar, sections: updated });
};


// Fetch Careers
const fetchCareers = async () => {
  const { data } = await axios.get(`${API}/api/careers`);
  setCareers(data);
};

useEffect(() => {
  fetchCareers();
}, []);

// Submit
const handleSubmitCar = async (e) => {
  e.preventDefault();

  if (editingCar) {
    await axios.put(`${API}/api/careers/${editingCar}`, formCar);
  } else {
    await axios.post(`${API}/api/careers`, formCar);
  }

  setShowModalCar(false);
  setEditingCar(null);

  setFormCar({
    post: "",
    experience: "",
    description: "",
    sections: [] ,
    vacancies: ""
  });

  fetchCareers();
};

// Edit
const handleEditCar = (c) => {
  setFormCar({
    post: c.post,
    experience: c.experience,
    description: c.description,
     sections: Array.isArray(c.sections) ? c.sections : [],
    vacancies: c.vacancies
  });
  setEditingCar(c.id);
  setShowModalCar(true);
};

// Delete
const handleDeleteCar = async (id) => {
  if (window.confirm("Delete this career?")) {
    await axios.delete(`${API}/api/careers/${id}`);
    fetchCareers();
  }
};

//---------------  Status Cards --------------------//

const [statusCards, setStatusCards] = useState([]);

const [formSC, setFormSC] = useState({
  name: "",
  count: ""
});

const [editingSC, setEditingSC] = useState(null);
const [showModalSC, setShowModalSC] = useState(false);

const fetchStatusCards = async () => {
  const { data } = await axios.get(`${API}/api/status-cards`);
  setStatusCards(data);
};

useEffect(() => {
  fetchStatusCards();
}, []);

const handleSubmitSC = async e => {
  e.preventDefault();

  if (editingSC) {
    await axios.put(`${API}/api/status-cards/${editingSC}`, formSC);
  } else {
    await axios.post(`${API}/api/status-cards`, formSC);
  }

  setFormSC({ name: "", count: "" });
  setEditingSC(null);
  setShowModalSC(false);
  fetchStatusCards();
};

const handleEditSC = (card) => {
  setFormSC({
    name: card.name,
    count: card.count
  });
  setEditingSC(card.id);
  setShowModalSC(true);
};

const handleDeleteSC = async (id) => {
  if (!window.confirm("Delete status card?")) return;
  await axios.delete(`${API}/api/status-cards/${id}`);
  fetchStatusCards();
};



//-----------Why Choose Cards -----------//



  const [cards, setCards] = useState([]);
  const [formWc, setFormWc] = useState({ name: "", status: "" });
  const [editingWc, setEditingWc] = useState(null);

  // Fetch cards
  const fetchCards = async () => {
    const { data } = await axios.get(`${API}/api/why-choose-cards`);
    setCards(data);
  };

  useEffect(() => {
    fetchCards();
  }, []);

  // Submit form
  const handleSubmitWc = async (e) => {
    e.preventDefault();
    if (editingWc) {
      await axios.put(`${API}/api/why-choose-cards/${editingWc}`, formWc);
    } else {
      await axios.post(`${API}/api/why-choose-cards`, formWc);
    }
    setFormWc({ name: "", status: "" });
    setEditingWc(null);
    fetchCards();
  };

  // Edit card
  const handleEditWc = (card) => {
    setFormWc({ name: card.name, status: card.status });
    setEditingWc(card.id);
  };

  // Delete card
  const handleDeleteWc = async (id) => {
    if (!window.confirm("Delete this card?")) return;
    await axios.delete(`${API}/api/why-choose-cards/${id}`);
    fetchCards();
  };


  // ----- Contacts -------//

const [contacts, setContacts] = useState([]);

// Pagination
const [currentPageF, setCurrentPageF] = useState(1);
const itemsPerPageF = 10;
const totalPagesF = Math.ceil(contacts.length / itemsPerPageF);

const currentItemsF = contacts.slice(
  (currentPageF - 1) * itemsPerPageF,
  currentPageF * itemsPerPageF
);

// Fetch Contacts
const fetchContacts = async () => {
  const { data } = await axios.get(`${API}/api/contacts`);
  setContacts(data);
};

useEffect(() => {
  fetchContacts();
}, []);




  const allNavItems = [
    { label: "Dashboard", icon: <MdDashboard /> },
   
  { label: "Hero Sliders", icon: <MdSlideshow /> },
    { label: "Projects", icon: <MdWork /> },


      { label: "Services Menus", icon: <MdApps/> },
       { label: "Services", icon: <MdBuild /> },
       { label: "Clients", icon: <MdPerson /> },
       { label: "Contact Forms", icon: <MdContactMail /> },

{ label: "Careers", icon: <MdBusinessCenter /> },
{ label: "Job Applications", icon: <MdAssignment /> },

{ label: "Status Cards", icon: <MdInsertChart /> },  
{ label: "Why Choose Cards", icon: <MdStar /> }

  
  ];


useEffect(() => {
    localStorage.setItem("activeComponent", activeComponent);
  }, [activeComponent]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(e.target)
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

const handleLogout = () => {
  sessionStorage.removeItem("isAdminLoggedIn");
  sessionStorage.removeItem("adminEmail");
  navigate("/admin-login");
};




  const renderContent = () => {



if (activeComponent === "Projects") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Projects</h2>

        <button
          onClick={() => {
            setFormP({ name: "", category: "Hospitality", country: "United Arab Emirates", image: null });
            setEditingP(null);
            setShowModalP(true);
          }}
          style={{
            background: "#132e55",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
<th style={{ padding: "6px 6px", height: "20px" }}>#</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Name</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Category</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Country</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Scope of Work</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Description</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Image</th>
<th style={{ padding: "6px 6px", height: "20px" }}>Actions</th>

          </tr>
        </thead>

        <tbody>
          {currentItemsP.map((p, i) => (
            <tr key={p.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.name}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.category}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.country}</td>
              {/* ADD */}

{/* ADD */}
<td style={{ border: "1px solid #ddd", textAlign: "center" }}>
  {p.scope_of_work}
</td>

<td style={{ border: "1px solid #ddd", textAlign: "center" }}>
  {p.description}
</td>


              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <img src={p.image} alt="project" style={{ width: 100, borderRadius: 6 }} />
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button
                  onClick={() => handleEditP(p)}
                  style={{ background: "var(--primary)", color: "#fff", marginRight: 6 }}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => handleDeleteP(p.id)}
                  style={{ background: "var(--accent)", color: "#132e55" }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
{totalPagesP > 1 && (
  <div
    style={{
      marginTop: 20,
      display: "flex",
      justifyContent: "center",
      gap: 6,
      alignItems: "center",
    }}
  >
    {/* Prev Button */}
    <button
      disabled={currentPageP === 1}
      onClick={() => setCurrentPageP((p) => p - 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        border: "1px solid #ccc",
        background: currentPageP === 1 ? "#eee" : "var(--primary)",
        color: currentPageP === 1 ? "#555" : "#fff",
        cursor: currentPageP === 1 ? "not-allowed" : "pointer",
      }}
    >
      Prev
    </button>

    {/* Page Numbers */}
    {Array.from({ length: totalPagesP }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPageP(page)}
        style={{
          padding: "6px 10px",
          border: "1px solid #ccc",
          borderRadius: 6,
          cursor: "pointer",
          background: currentPageP === page ? "var(--primary)" : "#fff",
          color: currentPageP === page ? "#fff" : "#333",
          fontWeight: currentPageP === page ? "bold" : "normal",
        }}
      >
        {page}
      </button>
    ))}

    {/* Next Button */}
    <button
      disabled={currentPageP === totalPagesP}
      onClick={() => setCurrentPageP((p) => p + 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        border: "1px solid #ccc",
        background: currentPageP === totalPagesP ? "#eee" : "var(--primary)",
        color: currentPageP === totalPagesP ? "#555" : "#fff",
        cursor: currentPageP === totalPagesP ? "not-allowed" : "pointer",
      }}
    >
      Next
    </button>
  </div>
)}


      {/* Modal */}
      {showModalP && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: 25,
               maxHeight: "90vh",   // <-- limits modal height
    overflowY: "auto",   // <-- enables vertical scroll
    scrollbarWidth: "thin", // <-- optional (Firefox)
            }}
          >


                  <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          borderBottom: "1px solid #eee",
          paddingBottom: 10,
        }}
      >
        <h3 style={{ color: "var(--primary)" }}>
              {editingP ? "Edit Project" : "Add Project"}
            </h3>
        <FaTimes
          onClick={() => setShowModalP(false)}
          style={{
            cursor: "pointer",
            color: "#555",
            fontSize: 18,
            transition: "0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "var(--accent)")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
        />
      </div>
           

            <form onSubmit={handleSubmitP} style={{ marginTop: 15 }}>
              
              <label>Project Name</label>
              <input
                type="text"
                value={formP.name}
                onChange={(e) => setFormP({ ...formP, name: e.target.value })}
                style={{   width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15}}
                required
              />

              <label>Category</label>
              <select
                value={formP.category}
                onChange={(e) => setFormP({ ...formP, category: e.target.value })}
                style={{   width: "100%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",
  marginBottom: 15 }}
              >
                <option>Hospitality</option>
                <option>Residential</option>
                <option>Mixed Use</option>
                <option>Corporate & Government</option>
                <option>Recreational</option>
                <option>Educational - House of Worship</option>
              </select>

              <label>Country</label>
              <select
                value={formP.country}
                onChange={(e) => setFormP({ ...formP, country: e.target.value })}
                style={{   width: "100%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer", 
    marginBottom: 15
  }}
              >
                <option>United Arab Emirates</option>
                <option>Kingdom of Saudi Arabia</option>
                <option>Oman</option>
                <option>India</option>
                <option>Iraq</option>
                <option>Tanzania</option>
                <option>Kuwait</option>
                <option>Ghana</option>
                <option>Egypt</option>
                <option>Bahrain</option>
                <option>Uganda</option>
                <option>Qatar</option>
              </select>
{/* Scope of Work */}
<label>Scope of Work</label>
<input
  type="text"
  value={formP.scope_of_work}
  onChange={(e) => setFormP({ ...formP, scope_of_work: e.target.value })}
  style={{
    width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",
    marginBottom: 15
  }}
/>

{/* Description */}
<label>Description</label>
<textarea
  value={formP.description}
  onChange={(e) => setFormP({ ...formP, description: e.target.value })}
  rows={4}
  style={{
    width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",
    marginBottom: 15,
    resize: "vertical"
  }}
/>

              <label>Image</label>
              <input type="file" onChange={handleImageP} style={{  width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer", marginBottom: 15 }} />

              {formP.image && (
                <img
                  src={
                    typeof formP.image === "string"
                      ? formP.image
                      : URL.createObjectURL(formP.image)
                  }
                  style={{ width: "100px", borderRadius: 8, marginBottom: 10 }}
                />
              )}

              <button
                type="submit"
                      style={{
            background: "var(--primary)",
            color: "#fff",
            padding: "10px 15px",
            borderRadius: 6,
            marginTop: 15,
            width: "100%",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            border: "none",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
              >
                {editingP ? "Update" : "Add"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


if(activeComponent==="Hero Sliders"){
   return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Hero Sliders</h2>

        <button
          onClick={() => {
            setForm({ title: "", location: "", image: null });
            setEditingID(null);
            setShowModal(true);
          }}
          style={{
            background: "#132e55",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            <th style={{ padding: 6 }}>Title</th>
            <th style={{ padding: 6 }}>Location</th>
            <th style={{ padding: 6 }}>Image</th>
            <th style={{padding:6}}>Order</th>
            <th style={{ padding: 6 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.map((slider, i) => (
            <tr key={slider.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {i + 1}
              </td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {slider.title}
              </td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {slider.location}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <img
                  src={slider.image}
                  style={{ width: 120, borderRadius: 6 }}
                  alt=""
                />
              </td>
 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {slider.order_no}
              </td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button
                  onClick={() => handleEdit(slider)}
                  style={{ background: "var(--primary)", color: "#fff", marginRight: 6 }}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => handleDelete(slider.id)}
                  style={{ background: "var(--accent)", color: "#132e55" }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPage === 1 ? "#eee" : "var(--primary)",
              color: currentPage === 1 ? "#555" : "#fff",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              style={{
                padding: "6px 10px",
                borderRadius: 6,
                background: currentPage === page ? "var(--primary)" : "#fff",
                color: currentPage === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPage === totalPages ? "#eee" : "var(--primary)",
              color: currentPage === totalPages ? "#555" : "#fff",
            }}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: 25,
            }}
          >
            {/* Title Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
            
                paddingBottom: 10,
              }}
            >
              <h3 style={{ color: "var(--primary)" }}>
                {editingID ? "Edit Slide" : "Add Slide"}
              </h3>
              <FaTimes
                onClick={() => setShowModal(false)}
                style={{ cursor: "pointer" }}
              />
            </div>

            <form onSubmit={handleSubmit}>

              {/* Title */}
              <label>Title</label>
              <input
                type="text"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                style={{
                  width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15
                }}
                required
              />

              {/* Location */}
              <label>Location</label>
              <input
                type="text"
                value={form.location}
                onChange={(e) => setForm({ ...form, location: e.target.value })}
                style={{
                  width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15
                }}
                required
              />

              {/* Image */}
              <label>Image</label>
              <input
                type="file"
                onChange={handleImage}
                style={{  width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15 }}
              />



              <label>Order</label>
<select
  value={form.order_no}
  onChange={(e) =>
    setForm({ ...form, order_no: e.target.value })
  }
  required
  style={{  width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15 }}
              
>
  <option value="">Select order</option>
  {orderOptions.map((n) => (
    <option key={n} value={n}>
      {n}
    </option>
  ))}
</select>


              {form.image && (
                <img
                  src={
                    typeof form.image === "string"
                      ? form.image
                      : URL.createObjectURL(form.image)
                  }
                  style={{ width: 100, borderRadius: 8, marginBottom: 10 }}
                />
              )}
              <button
                type="submit"
                     style={{
            background: "var(--primary)",
            color: "#fff",
            padding: "10px 15px",
            borderRadius: 6,
            marginTop: 15,
            width: "100%",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            border: "none",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
              >
                {editingID ? "Update" : "Add"}
              </button>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}


if (activeComponent === "Job Applications") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Applications</h2>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            <th style={{ padding: 6 }}>Job Title</th>
            <th style={{ padding: 6 }}>Name</th>
            <th style={{ padding: 6 }}>Email</th>
            <th style={{ padding: 6 }}>Mobile</th>
            <th style={{ padding: 6 }}>Resume</th>
            <th style={{ padding: 6 }}>Applied On</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsA.map((app, i) => (
            <tr key={app.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {(currentPage - 1) * itemsPerPage + i + 1}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {app.job_title}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {app.name}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {app.email}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {app.mobile}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <a
                  href={app.resume_file}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "var(--primary)",
                    fontWeight: 600,
                    textDecoration: "underline",
                  }}
                >
                  View Resume
                </a>
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>

                {new Date(app.created_at).toLocaleString("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
})}

              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPagesA > 1 && (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <button
            disabled={currentPageA === 1}
            onClick={() => setCurrentPageA((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPageA === 1 ? "#eee" : "var(--primary)",
              color: currentPageA === 1 ? "#555" : "#fff",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPagesA }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPageA(page)}
              style={{
                padding: "6px 10px",
                borderRadius: 6,
                background: currentPageA === page ? "var(--primary)" : "#fff",
                color: currentPageA === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPageA === totalPagesA}
            onClick={() => setCurrentPageA((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPageA === totalPagesA ? "#eee" : "var(--primary)",
              color: currentPageA === totalPagesA ? "#555" : "#fff",
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

if (activeComponent === "Services Menus") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <h2 style={{ color: "var(--primary)" }}>Services Menus</h2>

      {/* Add New Menu */}
      <form onSubmit={handleSubmitMenu} style={{ marginTop: 15, display:'flex', flexDirection:'row', alignItems:'center' }}>
        {/* <label>Menu Name</label> */}
        <input
          type="text"
          value={menuName}
          onChange={(e) => setMenuName(e.target.value)}
          placeholder="Enter menu name"
          style={{
            width: "350px",
            border: "1px solid #ccc",
            borderRadius: 6,
            padding: "8px",
            fontSize: 14,
        
          }}
          required
        />

        <button
          type="submit"
          style={{
            background: "var(--primary)",
            color: "#fff",
            padding: "8px 15px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            marginLeft: 10,
          }}
        >
          {editingIDSm ? "Update Menu" : "Add Menu"}
        </button>
      </form>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            <th style={{ padding: 6 }}>Menu Name</th>
            <th style={{ padding: 6 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsSm.map((menu, i) => (
            <tr key={menu.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {(currentPage - 1) * itemsPerPage + (i + 1)}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {menu.menu_name}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button
                  onClick={() => handleEditMenu(menu)}
                  style={{ background: "var(--primary)", color: "#fff", marginRight: 6 , cursor:'pointer'}}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => handleDeleteMenu(menu.id)}
                  style={{ background: "var(--accent)", color: "#132e55" ,  cursor:'pointer'}}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
          <button
            disabled={currentPageSm === 1}
            onClick={() => setCurrentPageSm((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPageSm === 1 ? "#eee" : "var(--primary)",
              color: currentPageSm === 1 ? "#555" : "#fff",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPagesSm}, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPageSm(page)}
              style={{
                padding: "6px 10px",
                borderRadius: 6,
                background: currentPageSm === page ? "var(--primary)" : "#fff",
                color: currentPageSm === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPageSm === totalPagesSm}
            onClick={() => setCurrentPageSm((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPage === totalPages ? "#eee" : "var(--primary)",
              color: currentPage === totalPages ? "#555" : "#fff",
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

  if (activeComponent === "Services") {
    return (
      <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 style={{ color: "var(--primary)" }}>Services</h2>

          <button
            onClick={() => {
              setFormS({
                menu_id: "",
                image: null,
                content: [{ heading: "", description: "" }],
              });
              setEditingS(null);
              setShowModalS(true);
            }}
            style={{
              background: "#132e55",
              color: "#fff",
              border: "none",
              padding: "8px 13px",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              height: "40px",
              cursor: "pointer",
            }}
          >
            <FaPlus style={{ marginRight: 6 }} /> Add
          </button>
        </div>

        {/* Table */}
        <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
          <thead style={{ background: "var(--primary)", color: "#fff" }}>
            <tr>
              <th  style={{ padding: 6 }}>#</th>
              <th  style={{ padding: 6 }}>Menu</th>
              <th  style={{ padding: 6 }}>Image</th>
              <th  style={{ padding: 6 }}>Content Count</th>
              <th  style={{ padding: 6 }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentItemsS.map((s, i) => (
              <tr key={s.id}>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.menu_name}</td>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  <img src={s.image} style={{ width: 80, borderRadius: 6 }} />
                </td>
           <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{JSON.parse(s.bullet_points).length} bullets</td>

                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  <button onClick={() => handleEditS(s)} style={{ background: "var(--primary)", color: "#fff" }}>
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDeleteS(s.id)}
                    style={{ background: "var(--accent)", color: "#132e55" }}
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        {totalPagesS > 1 && (
          <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
            <button disabled={currentPageS === 1} onClick={() => setCurrentPageS(currentPageS - 1)}>
              Prev
            </button>

            {Array.from({ length: totalPagesS }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPageS(page)}
                style={{
                  background: currentPageS === page ? "var(--primary)" : "#fff",
                  color: currentPageS === page ? "#fff" : "#333",
                }}
              >
                {page}
              </button>
            ))}

            <button disabled={currentPageS === totalPagesS} onClick={() => setCurrentPageS(currentPageS + 1)}>
              Next
            </button>
          </div>
        )}
        {/* Modal */}
        {showModalS && (
          <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      padding: "20px",          // EXTRA PADDING
      overflowY: "auto"         // 🔥 Scroll the backdrop if modal is tall
    }}
  >
          <div
            style={{
                     background: "#fff",
        borderRadius: 12,
        width: "100%",
        maxWidth: 500,
        maxHeight: "90vh",       // 🔥 Prevent height overflow
        overflowY: "auto",       // 🔥 Add scroll ONLY inside modal
        padding: 25,

            }}
          >
            <div style={{ background: "#fff", borderRadius: 12, width: "90%", maxWidth: 450, padding: 25 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>{editingS ? "Edit Service" : "Add Service"}</h3>
                <FaTimes style={{ cursor: "pointer" }} onClick={() => setShowModalS(false)} />
              </div>

              <form onSubmit={handleSubmitS}>
                {/* Menu */}
                <label>Menu</label>
                <select
                  value={formS.menu_id}
                  onChange={(e) => setFormS({ ...formS, menu_id: e.target.value })}
                  required
                  style={{ width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15}}
                >
                  <option value="">Select Menu</option>
                  {menus.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.menu_name}
                    </option>
                  ))}
                </select>

                {/* Image */}
                <label>Image</label>
                <input type="file" onChange={handleImageS}                style={{ width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15}}/>
                {formS.image && (
                  <img
                    src={typeof formS.image === "string" ? formS.image : URL.createObjectURL(formS.image)}
                    style={{ width: 100, marginTop: 1 }}
                  />
                )}

                {/* Dynamic Content Blocks */}
       <label>Paragraph</label>
<textarea
  value={formS.paragraph}
  onChange={(e) => setFormS({ ...formS, paragraph: e.target.value })}
  style={{ width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    marginTop: 15,
    cursor: "pointer",marginBottom: 15}}
/>

<label>Heading</label>
<input
  value={formS.heading}
  onChange={(e) => setFormS({ ...formS, heading: e.target.value })}
  style={{ width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15}}
/>

<label>Bullet Points (one per line)</label>
<textarea
  value={formS.bullet_points}
  onChange={(e) => 
    setFormS({ 
      ...formS, 
      bullet_points: e.target.value 
    })
  }
  placeholder="Type each bullet in a new line"
  style={{ width: "95%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",marginBottom: 15}}
/>



                <button type="submit"    style={{
            background: "var(--primary)",
            color: "#fff",
            padding: "10px 15px",
            borderRadius: 6,
            marginTop: 15,
            width: "100%",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            border: "none",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }>
                  {editingS ? "Update" : "Add"}
                </button>
              </form>
            </div>
          </div>
              </div>
        )}

      </div>
    );

  }

if (activeComponent === "Clients") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <h2 style={{ color: "var(--primary)" }}>Clients</h2>

      {/* Add / Edit Client Form */}
      <form 
        onSubmit={handleSubmitC}
        style={{ marginTop: 15 }}
      >
        
        {/* <input
          type="text"
          placeholder="Client Name"
          value={formC.client_name}
          onChange={(e)=>setFormC({...formC, client_name:e.target.value})}
          style={inputStyle}
        /> */}

        <label>Client Image</label>
        <input 
          type="file"
          onChange={handleImageC}
          style={inputStyle}
        />

        {formC.image && (
          <img
            src={typeof formC.image === "string"
              ? formC.image
              : URL.createObjectURL(formC.image)}
            style={{ width:100, marginTop:10 }}
          />
        )}

        <button 
          type="submit"
          style={btnStyle}
        >
          {editingC ? "Update Client" : "Add Client"}
        </button>
      </form>


      {/* Table */}
      <table style={tableStyle}>
        <thead style={theadStyle}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            {/* <th style={{ padding: 6 }}>Name</th> */}
            <th style={{ padding: 6 }}>Image</th>
            <th style={{ padding: 6 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {clients.map((c,i)=>(
            <tr key={c.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i+1}</td>
              {/* <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.client_name}</td> */}
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <img src={c.image} style={{width:80,borderRadius:6}} />
              </td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button
                  onClick={()=>handleEditC(c)}
                  style={editBtn}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={()=>handleDeleteC(c.id)}
                  style={deleteBtn}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
{/* {showModalC && (
<div className="modal">

<form onSubmit={handleSubmitC}>

<input
  type="text"
  placeholder="Client Name"
  value={formC.client_name}
  onChange={e => setFormC({...formC, client_name:e.target.value})}
/>

<input type="file" onChange={handleImageC} />

{formC.image && (
  <img
    src={typeof formC.image === "string"
      ? formC.image
      : URL.createObjectURL(formC.image)}
    style={{width:100}}
  />
)}

<button type="submit">
  {editingC ? "Update" : "Add"}
</button>

</form>
</div>
)} */}

    </div>
  );
}

if (activeComponent === "Status Cards") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <h2 style={{ color: "var(--primary)" }}>Status Cards</h2>

      {/* Add / Edit Form */}
      <form onSubmit={handleSubmitSC} style={{ marginTop: 15 }}>

        <input
          type="text"
          placeholder="Status Name"
          value={formSC.name}
          onChange={(e) => setFormSC({...formSC, name: e.target.value})}
           style={{
                  width: "300px", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", margin: 15, marginLeft:0
                }}
        />

        <input
          type="number"
          placeholder="Count"
          value={formSC.count}
          onChange={(e)=> setFormSC({...formSC, count: e.target.value})}
       style={{
                  width: "300px", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", margin: 15
                }}
        />

        <button type="submit" style={btnStyle}>
          {editingSC ? "Update" : "Add New"}
        </button>
      </form>


      {/* Table */}
      <table style={tableStyle}>
        <thead style={theadStyle}>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Count</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {statusCards.map((s, i) => (
            <tr key={s.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.name}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{s.count}</td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button onClick={() => handleEditSC(s)} style={editBtn}>
                  <FaEdit />
                </button>

                <button onClick={() => handleDeleteSC(s.id)} style={deleteBtn}>
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


      {/* MODAL */}
      {/* {showModalSC && (
        <div className="modal">

          <form onSubmit={handleSubmitSC}>

            <input
              type="text"
              placeholder="Status Name"
              value={formSC.name}
              onChange={(e)=> setFormSC({...formSC, name: e.target.value})}
            />

            <input
              type="number"
              placeholder="Count"
              value={formSC.count}
              onChange={(e)=> setFormSC({...formSC, count: e.target.value})}
            />

            <button type="submit">
              {editingSC ? "Update" : "Add"}
            </button>

          </form>

        </div>
      )} */}

    </div>
  );
}


if (activeComponent === "Contact Forms") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Contacts</h2>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            <th style={{ padding: 6 }}>Name</th>
            <th style={{ padding: 6 }}>Email</th>
            <th style={{ padding: 6 }}>Organization</th>
            <th style={{ padding: 6 }}>Subject</th>
            <th style={{ padding: 6 }}>Message</th>
            <th style={{ padding: 6 }}>Date</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsF.map((contact, i) => (
            <tr key={contact.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {(currentPage - 1) * itemsPerPage + i + 1}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {contact.name}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {contact.email}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {contact.organization}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {contact.subject}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                {contact.message}
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
             {new Date(contact.createdAt).toLocaleString("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
})}

              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPagesF > 1 && (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <button
            disabled={currentPageF === 1}
            onClick={() => setCurrentPageF((p) => p - 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPageF === 1 ? "#eee" : "var(--primary)",
              color: currentPageF === 1 ? "#555" : "#fff",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPagesF }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPageF(page)}
              style={{
                padding: "6px 10px",
                borderRadius: 6,
                background: currentPageF === page ? "var(--primary)" : "#fff",
                color: currentPageF === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPageF === totalPagesF}
            onClick={() => setCurrentPage((p) => p + 1)}
            style={{
              padding: "6px 12px",
              borderRadius: 6,
              background: currentPageF === totalPagesF ? "#eee" : "var(--primary)",
              color: currentPageF === totalPagesF ? "#555" : "#fff",
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}


if (activeComponent === "Careers") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Careers</h2>

      <button
  onClick={() => {
    setFormCar({
      post: "",
      experience: "",
      description: "",
      vacancies: "",
      sections: []   // ✅ THIS IS REQUIRED TO PREVENT CRASH
    });
    setEditingCar(null);
    setShowModalCar(true);
  }}
  style={{
    background: "#132e55",
    color: "#fff",
    border: "none",
    padding: "8px 13px",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    height: "40px",
    cursor: "pointer",
  }}
>
  <FaPlus style={{ marginRight: 6 }} /> Add
</button>

      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th style={{ padding: 6 }}>#</th>
            <th style={{ padding: 6 }}>Post</th>
            <th style={{ padding: 6 }}>Experience</th>
            <th style={{ padding: 6 }}>Vacancies</th>
                <th style={{ padding: 6 }}>Sections</th>
            <th style={{ padding: 6 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsCar.map((c, i) => (
            <tr key={c.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.post}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.experience} Years</td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.vacancies}</td>
<td style={{ border: "1px solid #ddd", fontSize: 12 }}>
  {Array.isArray(c.sections) && c.sections.length > 0
    ? c.sections.map(s => s.heading).join(", ").slice(0, 50) + "..."
    : "-"}
</td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button onClick={() => handleEditCar(c)} style={{ background: "var(--primary)", color: "#fff" }}>
                  <FaEdit />
                </button>
                <button
                  onClick={() => handleDeleteCar(c.id)}
                  style={{ background: "var(--accent)", color: "#132e55" }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPagesCar > 1 && (
        <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 6 }}>
          <button disabled={currentPageCar === 1} onClick={() => setCurrentPageCar(currentPageCar - 1)}>
            Prev
          </button>

          {Array.from({ length: totalPagesCar }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPageCar(page)}
              style={{
                background: currentPageCar === page ? "var(--primary)" : "#fff",
                color: currentPageCar === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button disabled={currentPageCar === totalPagesCar} onClick={() => setCurrentPageCar(currentPageCar + 1)}>
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {showModalCar && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "20px",
            overflowY: "auto"
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "100%",
              maxWidth: 500,
              maxHeight: "90vh",
              overflowY: "auto",
              padding: 25,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3>{editingC ? "Edit Career" : "Add Career"}</h3>
              <FaTimes style={{ cursor: "pointer" }} onClick={() => setShowModalCar(false)} />
            </div>

            <form onSubmit={handleSubmitCar}>

              <label>Post</label>
              <input
                type="text"
                value={formCar.post}
                required
                onChange={(e) => setFormCar({ ...formCar, post: e.target.value })}
                style={{
                  width: "95%", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", marginBottom: 15
                }}
              />

              <label>Years of Experience</label>
              <input
                type="number"
                value={formCar.experience}
                required
                onChange={(e) => setFormCar({ ...formCar, experience: e.target.value })}
                style={{
                  width: "95%", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", marginBottom: 15
                }}
              />

              <label>Description</label>
              <textarea
                value={formCar.description}
                required
                onChange={(e) => setFormCar({ ...formCar, description: e.target.value })}
                style={{
                  width: "95%", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", marginBottom: 15
                }}
              />

<h4>Job Sections</h4>

{Array.isArray(formCar.sections) &&
  formCar.sections.map((section, index) => (
  <div key={index} style={{ marginBottom: 15, border: "1px solid #ddd", padding: 10, borderRadius: 6 }}>
    
    <input
      type="text"
      placeholder="Heading (e.g. Key Skills, Work Experience)"
      value={section.heading}
      onChange={(e) => updateSection(index, "heading", e.target.value)}
      style={{ width: "100%", marginBottom: 8, padding: 6 }}
      required
    />

    <textarea
      placeholder="Content"
      value={section.content}
      onChange={(e) => updateSection(index, "content", e.target.value)}
      style={{ width: "100%", minHeight: 100, padding: 6 }}
      required
    />

    <button
      type="button"
      onClick={() => removeSection(index)}
      style={{ marginTop: 6, background: "red", color: "#fff", border: "none", padding: "4px 8px" }}
    >
      Delete Section
    </button>
  </div>
))}
<div style={{ marginBottom: 20 }}>
<button
  type="button"
  onClick={addSection}
  style={{ marginBottom: 20, background: "#132e55", color: "#fff", padding: "6px 10px", border: "none" }}
>
  + Add Section
</button>
</div>

              <label>No. of Vacancies</label>
              <input
                type="number"
                value={formCar.vacancies}
                required
                onChange={(e) => setFormCar({ ...formCar, vacancies: e.target.value })}
                style={{
                  width: "95%", border: "1px solid #ccc", borderRadius: 6,
                  padding: "8px", marginBottom: 15
                }}
              />

              <button
                type="submit"
                style={{
                  background: "var(--primary)",
                  color: "#fff",
                  width: "100%",
                  padding: "10px",
                  borderRadius: 6,
                  fontSize: 15,
                  border: "none",
                  cursor: "pointer"
                }}
              >
                {editingCar ? "Update" : "Add"}
              </button>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}


  if (activeComponent === "Why Choose Cards") 

  return (
 <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
  <h2 style={{ color: "var(--primary)" }}>Why Choose Cards</h2>

  {/* Add / Edit Form */}
  <form onSubmit={handleSubmitWc} style={{ marginTop: 15 }}>
    <input
      type="text"
      placeholder="Name"
      value={formWc.name}
      onChange={(e) => setFormWc({ ...formWc, name: e.target.value })}
      style={{
        width: "300px",
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: "8px",
        margin: 15,
        marginLeft: 0,
      }}
    />

    <input
      type="text"
      placeholder="Status"
      value={formWc.status}
      onChange={(e) => setFormWc({ ...formWc, status: e.target.value })}
      style={{
        width: "300px",
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: "8px",
        margin: 15,
      }}
    />

    <button type="submit" style={btnStyle}>
      {editingWc ? "Update" : "Add New"}
    </button>
  </form>

  {/* Table */}
  <table style={tableStyle}>
    <thead style={theadStyle}>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>

    <tbody>
      {cards.map((c, i) => (
        <tr key={c.id}>
          <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
          <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.name}</td>
          <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.status}</td>

          <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
            <button onClick={() => handleEditWc(c)} style={editBtn}>
              <FaEdit />
            </button>

            <button onClick={() => handleDeleteWc(c.id)} style={deleteBtn}>
              <FaTrash />
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

  );

    return (
   <div style={contentStyles.wrapper}>
  <h2 style={contentStyles.title}>Welcome, {adminEmail}</h2>
  <p style={contentStyles.subtitle}>This is your admin dashboard home.</p>
</div>

    );
  };

  return (
    <div style={baseStyles.container}>
      {/* Sidebar */}
      <div
        style={{
          ...baseStyles.sidebar,
          width: sidebarOpen ? "200px" : "70px",
        }}
      >
        <div style={baseStyles.logoArea}>
          {sidebarOpen ? (
            <div style={baseStyles.logoBlock}>
                  <span style={baseStyles.logoMain}>INFOSIGHT</span>
 
         
         
            </div>
          ) : (
            <span style={baseStyles.logoMain}>I</span>
          )}
        </div>

        <nav style={{ marginTop: "20px" }}>
          {allNavItems.map((item) => (
            <div
              key={item.label}
              style={{
                ...baseStyles.navItem,
                backgroundColor:
                  activeComponent === item.label
                    ? "rgba(255,255,255,0.15)"
                    : "transparent",
                color:
                  activeComponent === item.label ? "var(--accent)" : "#fff",
              }}
              onClick={() => setActiveComponent(item.label)}
            >
              <div style={baseStyles.navIcon}>{item.icon}</div>
              {sidebarOpen && (
                <span style={baseStyles.navLabel}>{item.label}</span>
              )}
            </div>
          ))}
        </nav>
      </div>

      {/* Main Area */}
      <div style={baseStyles.mainArea(sidebarOpen)}>
        <div style={headerStyles.header}>
          <div style={headerStyles.leftGroup}>
            <button onClick={toggleSidebar} style={headerStyles.toggleBtn}>
              <FaBars color="#fff" />
            </button>
          </div>

          <div style={headerStyles.profileArea} ref={profileMenuRef}>
            <FaUserCircle
              size={30}
              style={{ cursor: "pointer", color: "#fff" }}
              onClick={() => setShowProfileMenu((p) => !p)}
            />
            {showProfileMenu && (
              <div style={headerStyles.profileMenu}>
                <div
                  style={headerStyles.profileMenuItem}
                  onClick={handleLogout}
                >
                  <FaSignOutAlt style={{ marginRight: 8 }} /> Logout
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={baseStyles.contentWrapper}>{renderContent()}</div>
      </div>
    </div>
  );
};

export default AdminDashboard;

/* ---------- Styles ---------- */

const baseStyles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Segoe UI, sans-serif",
    background: "var(--bg-light)",
  },
  sidebar: {
    background: "linear-gradient(180deg, var(--primary) 0%, #132e55 100%)",
    color: "#fff",
    transition: "width 0.3s ease",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    padding: "15px 10px",
    boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
     overflowY: "auto",
  },
  logoArea: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  logoBlock: { lineHeight: 1.2 },
  logoMain: {
    fontWeight: "800",
    color: "#fff",
    fontSize: "1.3rem",
    letterSpacing: "0.5px",
        marginRight: "12px",
  },
  logoAccent: {
    color: "var(--accent)",
    fontWeight: "700",
    fontSize: "1.1rem",
    marginLeft: "4px",
  },
  logoTagline: {
    fontSize: "0.7rem",
    color: "#c9d1d9",
    marginTop: "3px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    marginBottom: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  navIcon: { fontSize: "18px", marginRight: "10px" },
  navLabel: { fontSize: "15px", fontWeight: "500" },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? "220px" : "70px",
    transition: "margin-left 0.3s ease",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentWrapper: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
};

const headerStyles = {
  header: {
    height: "60px",
    background: "linear-gradient(90deg, var(--primary), #132e55)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  leftGroup: { display: "flex", alignItems: "center" },
  toggleBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  },
  profileArea: { position: "relative" },
  profileMenu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 10px)",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  profileMenuItem: {
    padding: "10px 20px",
    cursor: "pointer",
    color: "var(--primary)",
    fontWeight: 500,
    borderBottom: "1px solid #eee",
  },
};

const contentStyles = {
 wrapper: {
    background: "linear-gradient(135deg, var(--white), var(--light))",
    borderRadius: "18px",
    padding: "35px",
    boxShadow:
      "0 14px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(8px)",
    transition: "0.3s ease-in-out",
  },

  title: {
    margin: 0,
    marginBottom: "14px",
    fontSize: "1.9rem",
    fontWeight: "700",
    letterSpacing: "0.6px",
    background: "linear-gradient(90deg, #e40613, #b30511)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    margin: 0,
    marginTop: "5px",
    fontSize: "1rem",
    color: "#555",
    fontWeight: "500",
    opacity: 0.85,
  },
  formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    flex: "0.3",
  },
  fileInput: {
    flex: "0.5",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  addBtn: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thead: { background: "var(--primary)", color: "#fff" },
  th: {
    textAlign: "left",
    padding: "10px",
    fontWeight: "600",
  },
  td: { padding: "10px", borderBottom: "1px solid #eee" },
  btnEdit: {
    background: "var(--primary)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
  },
  btnDelete: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  noData: { color: "#888", textAlign: "center", padding: "20px" },
};


// Common Styles
const tdStyle = {
  textAlign: "center",
  border: "1px solid #ddd",
  padding: "8px",
};

const modalBackdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  backdropFilter: "blur(3px)",
};

const modalBox = {
  background: "#fff",
  borderRadius: 14,
  width: "90%",
  maxWidth: 520,
  padding: "25px 30px 35px",
  boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
  position: "relative",
  animation: "fadeIn 0.4s ease",
  overflowY: "auto",
  maxHeight: "90vh",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "linear-gradient(90deg, #7B1E3A, #F2C94C)",
  padding: "12px 20px",
  borderRadius: "10px 10px 0 0",
};


const inputStyle = {
  width:"95%",
  border:"1px solid #ccc",
  borderRadius:6,
  padding:"8px",
  fontSize:14,
  marginBottom:15
};

const btnStyle = {
  background:"var(--primary)",
  color:"#fff",
  padding:"8px 15px",
  border:"none",
  borderRadius:6,
  cursor:"pointer"
};

const tableStyle = {
  width:"100%",
  marginTop:20,
  border:"1px solid #ddd"
};

const theadStyle = {
  background:"var(--primary)",
  color:"#fff"
};

const editBtn = {
  background:"var(--primary)",
  color:"#fff",
  marginRight:6,
  cursor:"pointer"
};

const deleteBtn = {
  background:"var(--accent)",
  color:"#132e55",
  cursor:"pointer"
};
